import { render } from "./SubBanner.vue?vue&type=template&id=64ba541d"
import script from "./SubBanner.vue?vue&type=script&lang=js"
export * from "./SubBanner.vue?vue&type=script&lang=js"

import "./SubBanner.vue?vue&type=style&index=0&id=64ba541d&lang=scss"

import exportComponent from "/Users/Sacha/PhpstormProjects/landgoedmorrenrun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__